
export interface ProductList {
    itemType: string;
    id: string;
    listing_id: string;
    title: string;
    category: string;
    price: number;
    quantity?: number;
    totalQuantity?: number;
    totalPrice?: number;
    availability: number;
    origPrice: number;
    finalPrice: number;
    discountVal: number;
    highPrice: number;
    img: string;
    localImg: string;
    //  score: number;
    //  lastUpdated: any;
    //  addedAt: number;
    //  numInstockStores: number;
    //  numTotalStores: number;
    //  numCoupons: number;
    //  noun: string;
    //  breadcrumbs: string[];
    //  lowest_price: number;
    //  upcoming: number;
    //  store: string;
    //  follow: number;
    // cod: bool;
    // storefulfilled: bool;
    // attributes: any[];
    // rating: number;
    // variants: any[];
    // sendToStore: number;
    // hotnessScore: number;
    // urlhash: number;
    // scandidUrl: string;
    // storeId: number;
    // airportId: number;
    // requiresRefresh: number;
    // gmrLocationNames: string[];
    // Location: string;
    // active: number;
    // catError: bool;
    // error: bool;
    // locationsMap: ;
    // status: number;
    // qTime: number;
    // // logParams: LogParams;
    // desc: string;
}

export interface ProductListAPIResponse {
    itemType: string;
    storeName: string;
    // retailerName: string;
    subCategory: string;
    // airportId: string;
    id: number;
    category: string;
    description: string;
    // type: number;
    // tags: string;
    // facilityName: string;
    // categoryList: string[];
    // locations: any[];
    locationName: string;
    storeImage: string;
    status: string;
    // storeImageList: string[];
    operatingHours: string;
    // isMenuItemsAvailable: number;
    // fos_user_id: number;
    // beta: number;
    // locationIdTA: string;
    locationsMap: any[];
    productList: ProductList[];
    cartDetails?: any[];
    // gmrOffers?: any;
    // storeRtaing: string;
}

export interface RetailDetailAPIResponse {
    itemType: string;
    storeName: string;
    // retailerName: string;
    subCategory: string;
    // airportId: string;
    id: number;
    category: string;
    description: string;
    // type: number;
    // tags: string;
    // facilityName: string;
    // categoryList: string[];
    // locations: any[];
    locationName: string;
    storeImage: string;
    status: string;
    // storeImageList: string[];
    operatingHours: string;
    // isMenuItemsAvailable: number;
    // fos_user_id: number;
    // beta: number;
    // locationIdTA: string;
    locationsMap: any[];
    // gmrOffers?: any;
    // storeRtaing: string;
    tabs: Tab[];
}

export interface OutletMetaInfo {
    tax?: any;
    flightInfoRequired: number;
    openingHours: string;
    timeSlots: number;
    deliveryType: string;
    hoursToOrder?: any;
    hoursForTimeslots?: any;
}

export interface Loc {
    itemType: string;
    id: number;
    retailer_id: number;
    airport_id: number;
    location: string;
    terminal: string;
    terminalSide: string;
    operatingHours: string;
    storeImage: string;
    status: string;
    openTime: number;
    closeTime: number;
    locationName: string;
    currentLocation: number;
    locations: string[];
    storeImageList: string[];
    address: string;
    outletMetaInfo: OutletMetaInfo;
}

export interface ValidFromDate {
    date: string;
    timezone_type: number;
    timezone: string;
}

export interface ValidTillDate {
    date: string;
    timezone_type: number;
    timezone: string;
}

export interface Coupon {
    id: number;
    store_id: string;
    title: string;
    code: string;
    barcode?: any;
    description: string;
    barcode_image_url: string;
    valid_from_date: ValidFromDate;
    valid_till_date: ValidTillDate;
    couponImage: string;
    subtitle: string;
    isRedeemed: number;
    instruction_to_use: string;
    isUpcoming: number;
    isExpired: number;
    isCollected: number;
    term_condition: string;
    validations: string;
}

export interface LocationsMap {
    5262: string;
}

export interface LogParamsList {
    key: string;
    val: string;
}

export interface MoreProduct {
    itemType: string;
    id: string;
    title: string;
    category: string;
    subcategory: string;
    category_id: number;
    price: number;
    availability: number;
    origPrice: number;
    finalPrice: number;
    discount: number;
    img: string;
    localImg: string;
    lastUpdated: any;
    addedAt: number;
    brand: string;
    noun: string;
    breadcrumbs: string[];
    breadcrumbsStore: string[];
    store: string;
    storeLogo: string;
    imageVariants: string[];
    size: string;
    department: string;
    desc: string;
    rating: number;
    variants: any[];
    skuid: string;
    sendToStore: number;
    hotnessScore: number;
    producthash: number;
    storeId: number;
    airportId: number;
    locationNames: string[];
    imageurl: string;
    Location: string;
    active: number;
    url_slug: string;
    productUrl: string;
    locationsMap: LocationsMap;
    redirectURL: string;
    transactionType: string;
    logParamsList: LogParamsList[];
    timestamp404: any;
    quantity: number;
}

export interface Data {
    des: string;
    tags: string;
    loc: Loc[];
    coupons: Coupon[];
    more_products: MoreProduct[];
}
export interface Tab {
    displayName: string;
    type: string;
    data: Data;
}

export const TabLabel: any = {
    ABOUT: 'About',
    COUPONS: 'Coupons',
    INVENTORY: 'inventory',
    REVIEWS: 'Reviews',
    COMMENTs: 'Comments'
};
